module.exports = __webpack_public_path__ + "img/music.10c583a5.svg";